export const AGENDA_FILTERS = 'AGENDA_FILTERS';
